import {defineAsyncComponent} from "vue";

export const templateList = {
    sams: {
        name: "山姆会员卡兑换",
        //banner图片
        // banner: require("@/assets/images/sams/sams_banner.png"),
        //项目logo
        logo: require("@/assets/images/sams/sams-logo.png"),
        stepImg: require("@/assets/images/sams/step.png"),
        productLogo: require("@/assets/images/sams/logo.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/sams/SamsIndexComponents.vue")
        }),
        //产品详情页组件
        detailComponents: defineAsyncComponent(() => import("@/components/sams/SamsDetailComponents.vue")),
        //订单详情组件
        orderDetailComponents: defineAsyncComponent(() => import("@/components/sams/SamsOrderDetailComponents.vue")),
        //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/sams/SamsOrderListComponents.vue"))
    },
    oct: {
        name: "华侨城欢乐谷",
        //banner图片
        banner: require("@/assets/images/oct/oct-banner.jpg"),
        //项目logo
        logo: "",
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/oct/OctIndexComponents.vue")
        }),
        //产品列表组件
        productComponents: defineAsyncComponent(() => {
            return import("@/components/oct/OctProductComponents.vue")
        }),
        //产品详情页组件
        detailComponents: defineAsyncComponent(() => import("@/components/oct/OctDetailComponents.vue")),
        //订单详情组件
        orderDetailComponents: defineAsyncComponent(() => import("@/components/oct/OctOrderDetailsComponents.vue")),
        //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/oct/OctOrderListComponents.vue")),
        catsType: {
            SCENIC_TICKET: "景区门票",
            YEAR_CARD: "电子年卡"
        }
    },
    lmb: {
        name: "乐摩吧",
        //banner图片
        banner: require("@/assets/images/lmb/lmb-banner.png"),
        //项目logo
        logo: require("@/assets/images/lmb/lmb-logo.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/lmb/LmbIndexComponents.vue")
        }),
        //产品详情页组件
        detailComponents: defineAsyncComponent(() => import("@/components/lmb/LmbDetailsComponents.vue")),
        //订单详情组件
        orderDetailComponents: defineAsyncComponent(() => import("@/components/lmb/LmbOrderDetailsComponents.vue")),
        //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/lmb/LmbOrderListComponents.vue")),
        catsType: {
            SCENIC_TICKET: "景区门票",
            YEAR_CARD: "电子年卡"
        }
    },
    yuetu: {
        name: "悦途休息室",
        //banner图片
        banner: require("@/assets/images/lmb/lmb-banner.png"),
        //项目logo
        logo: require("@/assets/images/lmb/lmb-logo.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/yuetu/YuetuIndexComponents.vue")
        }),
        //产品列表组件
        // intoComponents: defineAsyncComponent(() => {
        //     return import("@/components/lmb/LmbIntoComponents.vue")
        // }),
        //产品详情页组件
        detailComponents: defineAsyncComponent(() => import("@/components/yuetu/YuetuDetailComponents.vue")),
        //订单详情组件
        orderDetailComponents: defineAsyncComponent(() => import("@/components/yuetu/YuetuOrderDetailComponents.vue")),
        //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/yuetu/YuetuOrderListComponents.vue"))
    },
    lppz: {
        name: "良品铺子",
        //banner图片
        banner: require("@/assets/images/lppz/banner.png"),
        //项目logo
        logo: require("@/assets/images/lppz/logo.png"),
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/lppz/LppzIndexComponents.vue")
        }),
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/lppz/LppzStoreComponents.vue")
        }),
        // detailComponents: defineAsyncComponent(()=>{
        //     return import("@/components/lppz/LppzStoreComponents.vue")
        // }),
        orderListComponents: defineAsyncComponent(() => import("@/components/lppz/LppzOrderLstCComponents.vue")),
        storeIts: [
            {
                name: "四川省",
                data: require("@/utils/lppz-store/lpzz-sc.json")
            },
            // {
            //     name: "广东省",
            //     data: require("@/utils/lppz-store/lpzz-gd.json")
            // },
            // {
            //     name: "海南省",
            //     data: require("@/utils/lppz-store/lpzz-hn.json")
            // },
            // {
            //     name: "福建省",
            //     data: require("@/utils/lppz-store/lpzz-fj.json")
            // },
            // {
            //     name: "重庆市",
            //     data: require("@/utils/lppz-store/lpzz-cq.json")
            // }
        ]
    },
    blw: {
        name: "兵立王饮品",
        //banner图片
        banner: require("@/assets/images/blw/banner.png"),
        //项目logo
        logo: require("@/assets/images/blw/logo.png"),
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/lppz/LppzIndexComponents.vue")
        }),
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/blw/IndexComponents.vue")
        }),
        // detailComponents: defineAsyncComponent(()=>{
        //     return import("@/components/lppz/LppzStoreComponents.vue")
        // }),
        orderListComponents: defineAsyncComponent(() => import("@/components/blw/OrderComponents.vue")),
    },
    tft: {
        name: "川航金熊猫里程兑换天府通地铁乘车券",
        //项目logo
        // logo: require("@/assets/images/tft/logo.png"),
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/tft/TftIndexComponents.vue")
        }),
        orderListComponents: defineAsyncComponent(() => {
            return import("@/components/tft/TftDetailComponents.vue")
        })
    },
    fcz: {
        name: "飞常准",
        //项目logo
        // logo: require("@/assets/images/tft/logo.png"),
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/fcz/FczIndexComponent.vue")
        }),
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/tft/TftDetailComponents.vue")
        }),
        orderListComponents: defineAsyncComponent(() => import("@/components/fcz/FczOrderListComponents.vue"))
    },
    hssk: {
        name: "何师烧烤",
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/hssk/HsskIndex.vue")
        }),
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/hssk/HsskDetail.vue")
        }),
        orderListComponents: defineAsyncComponent(() => import("@/components/hssk/OrderLst.vue")),
        orderDetailComponents: defineAsyncComponent(() => import("@/components/hssk/OrderDetail.vue"))
    },
    tld: {
        name: "特来电",
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/tld/TldIndex.vue")
        }),
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/tld/TldDetail.vue")
        }),
        orderListComponents: defineAsyncComponent(() => import("@/components/tld/TldOrder.vue")),
    },
    youku: {
        name: "川航里程兑换优酷会员卡",
        banner: require("@/assets/images/youku/beijing.jpg"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/youku/YoukuIndexComponents.vue")
        }),
        // //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/youku/YoukuOrderListComponents.vue"))
    },
    naixue: {
        name: "奈雪的茶",
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/naxue/NaixueIndex.vue")
        }),
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/naxue/NaixueDetail.vue")
        }),
        orderListComponents: defineAsyncComponent(() => import("@/components/naxue/NaixueOrder.vue")),
    },
    taobo: {
        name: "川航里程兑滔博代金券",
        banner: require("@/assets/images/taobo/banner.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/taobo/TaoBoIndexComponents.vue")
        }),
        // //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/taobo/TaoBoOrderListComponents.vue"))
    },
    wanding: {
        name: "畹町",
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/wanding/WDIndex.vue")
        }),
        orderDetailComponents: defineAsyncComponent(() => import("@/components/wanding/WDDetail.vue")),
        orderListComponents: defineAsyncComponent(() => import("@/components/wanding/WDOrder.vue")),
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/wanding/WDStore.vue")
        }),
    },
    xyk: {
        name: "幸运咖",
        banner: require("@/assets/images/xyk/beijing.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/xyk/Index.vue")
        }),
        //产品明细组件
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/xyk/ProductDetail.vue")
        }),
        // //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/xyk/OrderList.vue"))
    },
    xxf: {
        name: "西西弗",
        banner: require("@/assets/images/xxf/banner.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/xxf/Index.vue")
        }),
        //订单明细组件
        orderDetailComponents: defineAsyncComponent(() => {
            return import("@/components/xxf/OrderDetail.vue")
        }),
        //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/xxf/OrderList.vue"))
    },
    jdwl: {
        name: "川航里程兑京东快递优惠券",
        // banner: require("@/assets/images/jdwl/banner.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/jdwl/Index.vue")
        }),
        // //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/jdwl/OrderList.vue"))
    },
    yonghui: {
        name: "永辉超市",
        // banner: require("@/assets/images/yonghui/banner.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/yonghui/Index.vue")
        }),
        //订单明细组件
        orderDetailComponents: defineAsyncComponent(() => {
            return import("@/components/yonghui/OrderDetail.vue")
        }),
        //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/yonghui/OrderList.vue"))
    },
    leke: {
        name: "乐刻健身",
        // banner: require("@/assets/images/leke/banner.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/leke/Index.vue")
        }),
        //产品明细组件
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/leke/Detail.vue")
        }),
        // //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/leke/OrderList.vue"))
    },
    darunfa: {
        name: "大润发",
        // banner: require("@/assets/images/darunfa/banner.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/darunfa/Index.vue")
        }),
        //订单明细组件
        orderDetailComponents: defineAsyncComponent(() => {
            return import("@/components/darunfa/OrderDetail.vue")
        }),
        //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/darunfa/OrderList.vue"))
    },
    yrh: {
        name: "雍容荟",
        // banner: require("@/assets/images/yrh/banner.png"),
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/yrh/Index.vue")
        }),
        //订单明细组件
        detailComponents: defineAsyncComponent(() => {
            return import("@/components/yrh/Detail.vue")
        }),
        //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/yrh/OrderList.vue"))
    },
    rawson: {
        name: "罗森便利店",
        //首页组件
        indexComponents: defineAsyncComponent(() => {
            return import("@/components/rawson/Index.vue")
        }),
        //订单明细组件
        orderDetailComponents: defineAsyncComponent(() => {
            return import("@/components/rawson/OrderDetail.vue")
        }),
        //订单列表组件
        orderListComponents: defineAsyncComponent(() => import("@/components/rawson/OrderList.vue"))
    }
}

export const rechargeView = {
    scal: defineAsyncComponent(() => import("@/components/login/SichuanAirportComponents.vue")),
    xm_air: defineAsyncComponent(() => import("@/components/login/XiamenAirportComponents.vue")),
}

export const week = [
    "日",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
]
export const ticketOctStatus = {
    INEFFECTIVE: "未生效",
    UNUSED: "未使用",
    ALL_USED: "已使用",
    PART_USED: "部分使用",
    ALL_INVALID: "已过期",
    EXPIRE_REFUND: "已过期",
    EXPIRE_SETTLE: "已过期",
};

export const ticketOrderState = {
    1: {
        value: "待付款",
        cls: "order-waite-pay"
    },
    11: {
        value: "确认订单",
        cls: "order-waite-pay-info"
    },
    12: {
        value: "确认订单",
        cls: "order-waite-pay-info"
    },
    13: {
        value: "支付中",
        cls: "order-waite-pay"
    },
    2: {
        value: "已付款",
        cls: "order-pay"
    },
    4: {
        value: "已过期",
        cls: "order-refund"
    },
    41: {
        value: "确认中",
        cls: "order-waite-pay"
    },
    5: {
        value: "已过期",
        cls: "order-refund"
    },
    3: {
        value: "已出票",
        cls: "order-pay"
    }
}

export const intoConf = {
    lmb: {
        name: "乐摩吧机场按摩券兑换",
        scoreType: [
            {type: 'scal', name: '金熊猫会员', air: ['四川航空'], status: 'success'},
            {type: 'xm_air', name: '白鹭会员', air: ['厦门航空','河北航空','江西航空'], status: 'success'},
            {type: 'china_air', name: '凤凰知音会员', air: ['中国国航','深圳航空','山东航空','澳门航空','北京航空等'], status: 'success'},
            {type: 'hainan_air', name: '金鹏会员', air: ['海南航空','天津航空','首都航空','祥鹏航空','西部航空等'], status: 'success'},
            // {type: 'icbc', name: '工银i豆积分兑换', status: 'success',url: 'https://payment.jifen360.com/third_coupon/third_page/BxprFPUAxNZk'},
        ],
        banner: require("@/assets/images/lmb/lmb-banner.png")
    },
    movie: {
        name: "航空积分兑换电影票",
        scoreType: [
            {
                type: 'scal',
                name: '四川航空金熊猫会员',
                status: 'success',
                url: 'https://sichuan-airlines.jifen360.com/movie/'
            },
            {
                type: 'xm_air',
                name: '厦门航空白鹭会员',
                status: 'success',
                url: 'https://movie.jifen360.com/pages/movies/index?platm=xm_air'
            },
            // {type:'china_air',name:'中国国际航空凤凰知音会员',status: 'success'},
        ],
    },
    cngg: {
        name: "航空积分兑换菜鸟裹裹",
        scoreType: [
            {
                type: 'scal',
                name: '四川航空金熊猫会员',
                status: 'success',
                url: 'https://ydzdd.guijitech.com/gateway/v1/page/index/#/scAirlines'
            },
            {
                type: 'xm_air',
                name: '厦门航空白鹭会员',
                status: 'success',
                url: 'https://payment.jifen360.com/cainiao/?from=xim'
            },
            // {type:'china_air',name:'中国国际航空凤凰知音会员',status: 'success'},
        ],
    },
    oct: {
        name: "航空积分兑换华侨城欢乐谷门票",
        scoreType: [
            {type: 'scal', name: '四川航空金熊猫会员', status: 'success'},
            {type: 'xm_air', name: '厦门航空白鹭会员', status: 'wait'}
        ],
        banner: require("@/assets/images/oct/oct-banner.jpg")
    },
    youku: {
        name: "优酷视频",
        scoreType: [
            {
                type: 'scal',
                name: '四川航空金熊猫会员',
                status: 'success',
                url: "https://payment.jifen360.com/third_coupon/?template=youku&recharge=scal&from=scal"
            },
            {
                type: 'xm_air',
                name: '厦门航空白鹭会员',
                status: 'success',
                url: "https://payment.jifen360.com/video/?type=youku"
            }
        ],
    },
    xim: {
        name: "喜马拉雅",
        scoreType: [
            {type: 'scal', name: '四川航空金熊猫会员', status: 'success', url: "https://chqjf.91bak.com/p/xmly"},
            {
                type: 'xm_air',
                name: '厦门航空白鹭会员',
                status: 'success',
                url: "https://payment.jifen360.com/video/?type=xim"
            }
        ],
    },
    iqiyi: {
        name: "爱奇艺",
        scoreType: [
            {
                type: 'scal',
                name: '四川航空金熊猫会员',
                status: 'success',
                url: "https://points-mall.fulu.com/?merchantId=6b94f2eb-976d-4d6f-9b81-de5a75705e80&groupId=e3f8971608ca4eeaa371870ab797e448"
            },
            {type: 'xm_air', name: '厦门航空白鹭会员', status: 'success', url: "https://payment.jifen360.com/iqiyi/"}
        ],
    },
    hanglv: {
        name: "航旅纵横",
        scoreType: [
            {
                type: 'scal',
                name: '四川航空金熊猫会员',
                status: 'success',
                url: "https://payment.jifen360.com/third_coupon/third_page/gUyAAvrdLYaK"
            },
            // {type: 'xm_air', name: '厦门航空白鹭会员', status: 'success',url:"https://payment.jifen360.com/video/?type=hanglv"}
        ],
    },
    jianfu: {
        name: "见福便利店",
        scoreType: [
            {
                type: 'scal',
                name: '四川见福便利店',
                status: 'success',
                url: "https://payment.jifen360.com/jf_mark/?mark=908D0E4DFD588E10CA40B68662C4565D&randome=20240312"
            },
            {
                type: 'xm_air',
                name: '福建见福便利店',
                status: 'success',
                url: "https://payment.jifen360.com/video/?type=hanglv"
            }
        ],
    }
}
